import { createAsyncThunk } from '@reduxjs/toolkit';

import { getMessageReadTime } from 'store/chat/services/getMessageReadTime';

export const getMessageReadTimeThunk = createAsyncThunk(
  'chat/getMessageReadTime',
  async ({ message, userId }, { getState, dispatch }) => {
    const state = getState();
    const { thread } = state.chatSlice;
    const response = await getMessageReadTime(
      thread.threadId || thread.id,
      userId,
      message.createdAt
    );
    return response;
  }
);
